import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../css/Contact.css';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'your_service_id',
      'your_template_id',
      form.current,
      'your_user_public_key'
    )
    .then(() => {
      alert('Message sent successfully!');
      form.current.reset();
    }, (error) => {
      alert('Failed to send message: ' + error.text);
    });
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>We’re here to help. Whether you're a business or freight partner, reach out to us.</p>

      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <input type="text" name="user_name" placeholder="Your Name" required />
        <input type="email" name="user_email" placeholder="Your Email" required />
        <textarea name="message" placeholder="Your Message" required />
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
}

export default Contact;
